'use client';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { elowenClient } from "../elowenClient";
import { QUERY_KEYS } from "../queries";
import { copyText } from "../clipboard";
import type { CliInstaller } from "../../../src/remoteCli/installScript";

/** Approve or deny a pending `elowen login`. An approval pairs the computer at once, so the register that
 *  now holds its Project is refetched; the code itself is spent either way. */
export function useDecideCliDeviceCode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { userCode: string; decision: 'approve' | 'deny' }) => elowenClient.decideCliDeviceCode(v.userCode, v.decision),
    onSuccess: (_result, v) => {
      qc.removeQueries({ queryKey: [...QUERY_KEYS.cliDeviceCode, v.userCode] });
      void qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}

/** Mint and copy once; a refused clipboard write cancels this exact mint before allowing another try.
 *  Only lifetime metadata is queried afterwards, never the ticket or command. */
export function useCreateCliEnrollment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (installer: CliInstaller) => {
      const enrollment = await elowenClient.createCliEnrollment(installer);
      const copied = await copyText(enrollment.command);
      if (!copied) await elowenClient.cancelCliEnrollment(enrollment.id);
      return copied;
    },
    onSettled: () => qc.invalidateQueries({ queryKey: QUERY_KEYS.cliEnrollment }),
  });
}
